module.exports = __webpack_public_path__ + "img/funding-new4.8d827198.png";